import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../lib/api";
import { useFmt } from "../context/CurrencyContext";
import { useCart } from "../context/CartContext";
import { resolveImageUrl } from "../components/ImageUpload";

export default function PresetBoxes() {
  const [boxes, setBoxes] = useState([]);
  const { addItem } = useCart();
  const fmtJMD = useFmt();

  useEffect(() => {
    api.get("/preset-boxes").then((r) => setBoxes(r.data)).catch(() => {});
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-12 py-12 sm:py-16" data-testid="preset-boxes-page">
      <div className="mb-10 sm:mb-12">
        <div className="overline text-zinc-500 mb-3">Pick Ah Box · JMD $5,400 each</div>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight">Pick Ah Box</h1>
        <p className="mt-3 sm:mt-4 text-zinc-600 text-base sm:text-lg max-w-2xl">
          Three signature combinations we stand behind. Perfect for gifting or a first-time order.
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
        {boxes.map((b) => (
          <div key={b.id} className="rounded-2xl overflow-hidden bg-white border border-zinc-100 hover:shadow-xl transition" data-testid={`preset-box-${b.id}`}>
            <div className="aspect-[4/3] overflow-hidden">
              <img src={resolveImageUrl(b.image_url)} alt={b.name} className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" />
            </div>
            <div className="p-5 sm:p-6">
              <div className="font-display font-bold text-lg sm:text-xl break-words">{b.name}</div>
              <p className="text-sm text-zinc-500 mt-1 break-words">{b.description}</p>
              <ul className="mt-4 text-sm space-y-1">
                {b.flavour_names.map((f) => (
                  <li key={f} className="flex items-center gap-2 text-zinc-700">
                    <span className="w-1 h-1 rounded-full bg-[#F74B64] flex-shrink-0" /> <span className="break-words">{f}</span>
                  </li>
                ))}
              </ul>
              <div className="mt-5 sm:mt-6 flex items-center justify-between gap-3 flex-wrap">
                <div className="font-display font-bold text-lg sm:text-xl whitespace-nowrap">{fmtJMD(b.price)}</div>
                <button
                  className="btn-primary text-sm"
                  onClick={() => {
                    addItem({
                      type: "preset_box", ref_id: b.id, name: b.name,
                      price: b.price, quantity: 1, image_url: b.image_url,
                    });
                    toast.success(`${b.name} added to cart`);
                  }}
                  data-testid={`add-preset-${b.id}`}>
                  Add to cart
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
